import React, { useState } from 'react';
import './NavigationItem.css';

interface NavigationItemProps {
  icon: React.ReactNode;
  label: string;
  path: string;
  isActive: boolean;
  isCollapsed: boolean;
  onClick: () => void;
}

const NavigationItem: React.FC<NavigationItemProps> = ({
  icon,
  label,
  path,
  isActive,
  isCollapsed,
  onClick
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleClick = () => {
    onClick();
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <div
      className={`nav-item ${isActive ? 'active' : ''} ${isCollapsed ? 'collapsed' : ''}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      role="button"
      tabIndex={0}
      aria-label={label}
      aria-current={isActive ? 'page' : undefined}
    >
      <span className="nav-icon" aria-hidden="true">{icon}</span>
      {!isCollapsed && <span className="nav-label">{label}</span>}
      
      {isCollapsed && showTooltip && (
        <div className="nav-tooltip" role="tooltip">
          {label}
        </div>
      )}
    </div>
  );
};

export default NavigationItem;
